<script>
    import { fade } from 'svelte/transition';

    export let title

    let open = false;

    function toggleContent(){
        if(open == false){
            open = true;
        }else{
            open = false;
        }
    }
</script>
<div class="accordion-wrapper">
    <div class="accordion-bar" class:openaccordion={open} on:click={toggleContent} on:keydown={toggleContent}>
        <div class="title-text">
            <span>{title}</span>
        </div>
        <div class="chevron-down"></div>
    </div>
</div>
{#if open}
    <div class="accordion-main-content" in:fade="{{ y: 0, duration: 200 }}" out:fade="{{ y: 0, duration: 50 }}">
        <slot></slot>
    </div>
{/if}
<style>

.accordion-wrapper{
    margin-bottom: 5px;
    z-index: 1;
}
.accordion-bar{
    width: 100%;
    min-height: 65px;
    background-color: #000;
    border-radius: 100px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    position: relative;
    cursor: pointer;
}

.accordion-main-content{
    padding: 15px 0;
}

.accordion-bar span{
    color: #fff;
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 700;
    user-select: none;
}

.accordion-bar .title-text{
    padding: 15px 75px;
    box-sizing: border-box;
    text-align: center;
}

.accordion-bar .chevron-down{
    position: absolute;
    right: 30px;
}

:global(.accordion-bar.openaccordion .chevron-down) {
    transform: rotate(-180deg);
}
</style>